export class SubordinatesNode {
  Children?: SubordinatesNode[];
  Item: SubordinateItem;
}

export class SubordinatesFlatNode {
  id: string;
  name: string;
  level: number;
  expandable: boolean;
}

export class SubordinateItem {
  Id: string;
  Name: string;
}
